import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import * as Util from '@/functions/Util';

export default class ProClienteValidation extends DefaultValidation{

    validate(root, cliente, cidade, refs) {
        let validated = true;

        if (Util.isNull(cliente.nome)) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cliente.rsocial)) {
            refs.rsInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cidade)) {
            refs.cidadeInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cliente.endereco)) {
            refs.enderecoInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cliente.bairro)) {
            refs.bairroInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cliente.cep)) {
            refs.cepInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cliente.cnpj) || !Util.validateCnpj(cliente.cnpj)) {
            refs.cnpjInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(cliente.email) && !Util.validateEmail(cliente.email)) {
            refs.emailInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(cliente.telefone) && !Util.validatePhone(cliente.telefone)) {
            refs.telefoneInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(cliente.fax) && !Util.validatePhone(cliente.fax)) {
            refs.faxInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(cliente.celular) && !Util.validatePhone(cliente.celular)) {
            refs.celularInput.focusedOut = true;
            validated = false;
        }
        if (!Util.isNull(cliente.ie) && !Util.validateIE(cliente.ie)) {
            refs.ieInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(cliente.cep) || !Util.validateCEP(cliente.cep)) {
            refs.cepInput.focusedOut = true;
            validated = false;
        }

        if (!validated){
            root.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        return validated;
    }

}